import { useTranslation } from 'react-i18next';
import { Modal, Tabs } from '@teo/components';
import { useContext, useState } from 'react';
import { Portal } from '@/components/Portal';
import { ImageAI } from './ImageAI';
import { LibraryTab } from './LibraryTab';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { OrgLibrary } from './OrgLibrary';
import { NewImageToLibrary } from '../NewImageToLibrary';
import { UploadTab } from './UploadTab';
import { useGet } from '@/query/fetchHooks';
import i18n from 'i18next';

export const LibraryModal = ({
  setIsOpenLibraryModal,
  isOpenLibraryModal,
  lessonPage,
  setUploadFile,
  onSelectImage,
}) => {
  const { t } = useTranslation();

  const { auth } = useContext(AuthContext);
  const authUser = auth?.user;

  const useTeoAi = authUser?.useTeoAi;

  const [tab, setTab] = useState(
    !lessonPage ? 'upload' : useTeoAi ? 'ai-teo' : 'library'
  );
  const [isOpenAddModal, setIsOpenAddModal] = useState(false);
  const [primaryTags, setPrimaryTags] = useState(null);

  const closeModal = () => {
    setIsOpenLibraryModal(!isOpenLibraryModal);
  };

  const tagsFilter = [
    {
      label: t('modal_library.filter.electricity'),
      value: 'electricity',
    },
    {
      label: t('modal_library.filter.base'),
      value: 'base',
    },
    {
      label: t('modal_library.filter.technology'),
      value: 'technology',
    },
    {
      label: t('modal_library.filter.safety'),
      value: 'safety',
    },
    {
      label: t('modal_library.filter.mechanics'),
      value: 'mechanics',
    },
  ];

  useGet('/tags', {
    primary: true,
    lang: i18n.language,
    onSuccess: (result) => {
      const tags = result?.data ?? [];
      const pTags = tags?.map((tag) => ({
        label: tag?.tag,
        value: tag?.tag,
      }));
      const missingCount = Math.max(0, 5 - pTags?.length);
      setPrimaryTags([
        ...pTags.slice(0, 5),
        ...tagsFilter.slice(0, missingCount),
      ]);
    },
  });

  return (
    <>
      {!isOpenAddModal ? (
        <Portal root="body">
          <div className="z-10 bg-white">
            <Modal isOpen={isOpenLibraryModal}>
              <Modal.Header onClose={() => closeModal()}>
                {t('widgets.type.add_image')}
              </Modal.Header>
              <Modal.Body>
                <div className="flex flex-col lg:flex-row">
                  <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
                    {!lessonPage && (
                      <Tabs.TabButton name="upload">
                        <p className="text-base font-medium">
                          {t(
                            'pages.create_edit_course.video_upload_modal.upload'
                          )}
                        </p>
                      </Tabs.TabButton>
                    )}
                    {useTeoAi && (
                      <Tabs.TabButton name="ai-teo">
                        <p className="text-base font-medium">TEO AI</p>
                      </Tabs.TabButton>
                    )}
                    {/* <Tabs.TabButton name="library">
                      <p className="text-base font-medium">Library</p>
                    </Tabs.TabButton> */}
                    <Tabs.TabButton name="org-library">
                      <p className="text-base font-medium">Library</p>
                    </Tabs.TabButton>
                  </Tabs>
                </div>
                {tab === 'upload' && (
                  <UploadTab
                    setIsOpenLibraryModal={setIsOpenLibraryModal}
                    isOpenLibraryModal={isOpenLibraryModal}
                    setUploadFile={setUploadFile}
                  />
                )}
                {tab === 'library' && (
                  <LibraryTab
                    setIsOpenLibraryModal={setIsOpenLibraryModal}
                    isOpenLibraryModal={isOpenLibraryModal}
                    tagsFilter={primaryTags}
                    lessonPage={lessonPage}
                    setUploadFile={setUploadFile}
                  />
                )}

                {tab === 'ai-teo' && useTeoAi && (
                  <ImageAI
                    setIsOpenLibraryModal={setIsOpenLibraryModal}
                    isOpenLibraryModal={isOpenLibraryModal}
                    tagsFilter={primaryTags}
                    lessonPage={lessonPage}
                    setUploadFile={setUploadFile}
                  />
                )}
                {tab === 'org-library' && (
                  <OrgLibrary
                    authUser={authUser}
                    setIsOpenLibraryModal={setIsOpenLibraryModal}
                    isOpenLibraryModal={isOpenLibraryModal}
                    tagsFilter={primaryTags}
                    lessonPage={lessonPage}
                    setIsOpenAddModal={setIsOpenAddModal}
                    isOpenAddModal={isOpenAddModal}
                    onSelectImage={onSelectImage}
                  />
                )}
              </Modal.Body>
            </Modal>
          </div>
        </Portal>
      ) : (
        <NewImageToLibrary
          isOpenNewLibraryModal={isOpenAddModal}
          setIsOpenNewLibraryModal={setIsOpenAddModal}
          setIsOpenLibraryModal={setIsOpenLibraryModal}
          isOpenLibraryModal={isOpenLibraryModal}
          onSelectImage={onSelectImage}
          isModal={true}
        />
      )}
    </>
  );
};
